import { useRecoilTask } from 'recoil-toolkit';

import { incidentLogsByIdState } from './atoms';
import { getIncidentLogsTask } from './tasks';

export const useIncidentLogsList = (incident: number) => useRecoilTask(getIncidentLogsTask, [], {
  dataSelector: incidentLogsByIdState(incident),
  errorStack: true,
});
